// extracted by mini-css-extract-plugin
export default {"header":"Xw","fullPage":"Yw","closed":"Zw","minimize":"ax","redcircle":"bx","container":"cx","text":"ex","centered":"fx","escapex":"gx"};
    if(module.hot) {
      // 1730991502590
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  